import { Text } from "@simplybusiness/mobius";
import type { AgentReferralTextProps } from "./types";

export const AgentReferralText = (props: AgentReferralTextProps) => {
  const { firstName, referenceNumber, phoneNumber } = props;

  return (
    <div className="mobius-agent-referral__text">
      <Text elementType="h2">Thanks, {firstName}</Text>
      <Text variant="body">
        We&apos;re sorry, but we can&apos;t offer a quote based on the answers
        you provided.
      </Text>
      <Text variant="body">
        We&apos;d be happy to explain further. Feel free to talk with one of our
        agents at <strong>{phoneNumber}</strong>. Please keep this reference
        number <strong>{referenceNumber}</strong> handy when you call.
      </Text>
      <Text elementType="h3">Did you know?</Text>
      <Text variant="body">
        Among the trades agents quote the most with us include painting and wall
        covering, handyperson, and carpentry, each covering up to $1 million per
        occurrence.
      </Text>
    </div>
  );
};
